export default "__VITE_ASSET__BUdFCY3u__"